import { includes } from "lodash";
import httpRequest from "./httpRequest";
import { Http } from "@material-ui/icons";
import { VERIFY_OTP, SEND_OTP_URL, VERIFY_FR, FETCH_CURRENT_USER } from "./apiLists";
import dayjs from "dayjs";

class DeleteAccountService {



//   "emaployee_id": "test1@jukshio.com",
//   "deactivate": true,
//   "app_id": "aso"

  deActiveUserAccount = async (
    userID: string | any ,) => {
    let formdata = new FormData();
    const isUserDeleteTrue :any=  true
    formdata.append("employee_id", userID);
    formdata.append("deactivate", isUserDeleteTrue);
    formdata.append("app_id", "aso");

    console.log(formdata, "formatted data====>")

    let form11 =  {
      "employee_id": userID,
      "deactivate":isUserDeleteTrue,
      "app_id": "aso"
    }

    const stringifiedData =  JSON.stringify(form11)
    
    console.log(stringifiedData, "new formatedc ata")

    const DEACTIVATE_USER_ACCOUNT =  "deactivate_employee"
    const accountDeleteBaseUrl = "https://amt-gcp-dev.soham.ai/admin-module/v1/"
    // https://amt-gcp-dev.soham.ai/admin-module/v1/deactivate_employee' 

    const token = window.localStorage.getItem("auth_token");

    const url = `${accountDeleteBaseUrl}${DEACTIVATE_USER_ACCOUNT}`;
    const data = await httpRequest.post(url, stringifiedData, {
      headers: { "Content-Type": "application/json" ,
        Authorization: `Bearer ${token}`,
      },
    });

    if (data.status === 200) {
      return {
        ...data,
      };
    }
    return {};
  };

  deleteUserAccountPermanent = async (
 userID: string | any ,) => {
    
    // const accountDeleteBaseUrl = "https://amt-gcp-dev.soham.ai/admin-module/v1/"
    const DELETE_USER_ACCOUNT =  "delete_employee"
    const params  =  `?employee_id=${userID}&permanent_delete=false`

    // 'https://amt-gcp-prod.soham.ai/admin-module/v1/delete_employee?employee_id=test1%40jukshio.com&permanent_delete=false'

    const token = window.localStorage.getItem("auth_token");

    const url = `${httpRequest.deleteuserurl}${DELETE_USER_ACCOUNT}${params}`;


    const data = await httpRequest.delete(url, {
      headers: { "Content-Type": "application/json" ,
        Authorization: `Bearer ${token}`,
      },
    });

    if (data.status === 200) {
      return {
        ...data,
      };
    }
    return {};
  };


  activateUser = async (
    userID: string | any ,) => {
    let formdata = new FormData();
    const isUserDeleteTrue :any=  false //activating user
    formdata.append("emaployee_id", "pankaj.gaur@jukshio.com");
    formdata.append("deactivate", isUserDeleteTrue);
    formdata.append("app_id", "aso");

    const DEACTIVATE_USER_ACCOUNT =  "deactivate_employee"
    // const accountDeleteBaseUrl = "https://amt-gcp-dev.soham.ai/admin-module/v1/"
    // https://amt-gcp-dev.soham.ai/admin-module/v1/deactivate_employee' 

    const token = window.localStorage.getItem("auth_token");

    const url = `${httpRequest.deleteuserurl}${DEACTIVATE_USER_ACCOUNT}`;
    const data = await httpRequest.post(url, formdata, {
      headers: { "Content-Type": "application/json" ,
        Authorization: `Bearer ${token}`,
      },
    });

    if (data.status === 200) {
      return {
        ...data,
      };
    }
    return {};
  };



}

const deleteAccountService = new DeleteAccountService();

export default deleteAccountService;
